import * as v from 'valibot';

export const AccordionStoreSchema = v.record(
	v.string(),
	v.undefinedable(
		v.record(
			v.string(),
			v.undefinedable(
				v.object({
					defaultItemOpenedState: v.nullable(v.boolean()),
					// Because of the transformation from tuples to Map,
					// we need separate schemas for parsing and stringification
					items: v.pipe(
						v.array(v.tuple([v.union([v.string(), v.number()]), v.boolean()])),
						v.transform((record) => new Map(record)),
					),
				}),
			),
		),
	),
);

export const AccordionStoreStringifySchema = v.record(
	v.string(),
	v.undefinedable(
		v.record(
			v.string(),
			v.undefinedable(
				v.object({
					defaultItemOpenedState: v.nullable(v.boolean()),
					// Because of the transformation from Map to tuples,
					// we need separate schemas for parsing and stringification
					items: v.pipe(
						v.map(v.union([v.string(), v.number()]), v.boolean()),
						v.transform((map) => [...map]),
					),
				}),
			),
		),
	),
);

export type AccordionStoreSchemaType = v.InferOutput<
	typeof AccordionStoreSchema
>;

export type AccordionState = NonNullable<
	NonNullable<AccordionStoreSchemaType[string]>[string]
>;

export type AccordionItemsState = AccordionState['items'];

export type AccordionItemID =
	AccordionItemsState extends Map<infer Key, unknown> ? Key : never;

export type DispatchOpenedItems = import('react').Dispatch<
	Parameters<typeof import('./accordionStateReducer').accordionStateReducer>[1]
>;

export type AccordionContextType = {
	accordionState: AccordionState;
	dispatchOpenedItems: DispatchOpenedItems;
	defaultOpened: Set<AccordionItemID> | undefined;
};
